import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const dataLayerPush = (data) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
};

const useAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    dataLayerPush({
      event: "page_view_custom",
      page_location: window.location.href,
      page_title: document.title,
      page_path: location.pathname,

      ecommerce: null,
      user_id: undefined,
      user_data: undefined,
    });

    dataLayerPush({
      browser_details_raw: window.navigator.userAgent,
      browser_language: window.navigator.language,
    });
  }, [location.pathname]);
};

export default useAnalyticsTracker;
